//src/components/Layout.tsx
import Header from "./Header";
import Footer from "./Footer";
import { useAuth } from "@/hooks/useAuth";
import LoadingSpinner from "./LoadingSpinner";
import CheckoutStatusModal from "./CheckoutStatusModal";
import OfflineBanner from "./OfflineBanner";
import OfflineScreen from "./OfflineScreen";
import { useOnlineStatus } from "@/hooks/useOnlineStatus";

interface LayoutProps {
  children: React.ReactNode;
  showFooter?: boolean;
}

export default function Layout({ children, showFooter = true }: LayoutProps) {
  const { logoutMutation, revokeSessionMutation } = (useAuth() as any) || {};
  const online = useOnlineStatus();
  return (
    <div className="min-h-screen bg-[hsl(226,26%,7%)] text-[hsl(210,9%,91%)]" role="document">
      {/* Toast notifications removed globally */}
      <CheckoutStatusModal />
      {(logoutMutation?.isPending || revokeSessionMutation?.isPending) && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50">
          <LoadingSpinner className="w-12 h-12" />
        </div>
      )}
      <Header />
      {online ? <OfflineBanner /> : null}
      {/* Landmark main region for accessibility; padding offsets fixed header */}
      <main id="main" role="main" className="pt-16">
        {online ? children : <OfflineScreen />}
      </main>
      {showFooter && online ? <Footer /> : null}
    </div>
  );
}
